module.exports = __webpack_public_path__ + "img/about_img_2.b5cc755b.svg";